/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SyncModelsResult } from '../../models/sync-models-result';

export interface ApiAdminModelsRealtimeSyncPost$Params {
  gatewayCode?: string;
}

export function apiAdminModelsRealtimeSyncPost(http: HttpClient, rootUrl: string, params?: ApiAdminModelsRealtimeSyncPost$Params, context?: HttpContext): Observable<StrictHttpResponse<SyncModelsResult>> {
  const rb = new RequestBuilder(rootUrl, apiAdminModelsRealtimeSyncPost.PATH, 'post');
  if (params) {
    rb.query('gatewayCode', params.gatewayCode, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SyncModelsResult>;
    })
  );
}

apiAdminModelsRealtimeSyncPost.PATH = '/api/Admin/models/realtime/sync';
